module.exports = __webpack_public_path__ + "static/Importation-mobile-25ddd73e3e8e522ab2330d84ed6782a7.gif";